/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SearchLoupeIcon16Light = forwardRef('SearchLoupeIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.5 1.751a5.749 5.749 0 1 0 3.696 10.152l2.706 2.705a.5.5 0 1 0 .707-.707l-2.706-2.705A5.749 5.749 0 0 0 6.5 1.751ZM1.751 7.5a4.749 4.749 0 1 1 9.498 0 4.749 4.749 0 0 1-9.498 0Z" })));
});
